<template>
<div class="null_content">
  <img src="../../assets/null.jpg" alt="">
  <!--<p>暂时还没有课程哦~</p>-->
  <p>{{tip}}</p>
</div>
</template>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less" rel="stylesheet/less">
  .null_content{
    text-align: center;
    padding: 150px 0;
    background-color: #fff;
    margin-top: 30px;
    p{
      font-size: 14px;
      color: #999;
      margin-top: 10px;
    }
  }
</style>
<script type="text/ecmascript-6">
    export default {
        name: '',
        props: ['tip'],
        data() {
            return {};
        },
        methods: {},
        created() {

        },
        components: {}
    }
</script>



// WEBPACK FOOTER //
// src/components/template/null.vue